import { render, staticRenderFns } from "./ParcelGalleryButton.vue?vue&type=template&id=21e8b42c&scoped=true&"
import script from "./ParcelGalleryButton.vue?vue&type=script&lang=js&"
export * from "./ParcelGalleryButton.vue?vue&type=script&lang=js&"
import style0 from "./ParcelGalleryButton.vue?vue&type=style&index=0&id=21e8b42c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e8b42c",
  null
  
)

export default component.exports